export enum AuditChangeType {
    Add = 1,
    Update,
    Remove,
}
